<template>
  <div v-if="count > 0">
    <slot></slot>
  </div>

  <div v-else :class="{'empty_message--container': isEmptyBoxed}">
    <div :class="['empty_message--box', size, {'is-boxed': isEmptyBoxed}]">
      <h4 :class="['empty_message--heading', size]">{{ heading }}</h4>

      <p v-if="$slots.message" :class="['empty_message--message', size]">
        <slot name="message"></slot>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "AppEmptyMessage",
  props: {
    count: {
      type: Number,
      required: true
    },
    heading: {
      type: String,
      required: true
    },
    size: {
      type: String,
      default: ""
    },
    isEmptyBoxed: {
      type: Boolean,
      default: false,
    },
  }
};
</script>

<style lang="scss" scoped>
@import "../../styles/variables/variables";

.empty_message {
  max-width: 600px;
  margin: 40px auto;

  &--container {
    display: flex;
    flex-grow: 1;
    justify-content: center;
    align-items: center;
  }

  &--box {
    margin: 80px auto;
    text-align: center;

    &.is-boxed {
      padding: 4rem 6rem;
      border: 1px solid $borderDark;
    }

    &.is-small {
      margin: 20px auto;
    }
  }

  &--heading {
    font-size: 2rem;
    color: $text-muted;
    line-height: 1.3;

    &.is-small {
      font-size: 1rem;
    }
  }

  &--message {
    max-width: 800px;
    margin: 0 auto;
    font-size: 1.25rem;
    color: $text-light;
    line-height: 1.5;

    &.is-small {
      font-size: 1rem;
    }
  }
}
</style>
